export default __webpack_public_path__ + "static/media/comingSoon.788cdd21.txt";